import {FloteResponse} from "@/lib/api/response/FloteResponse";
import {ResponseField} from "@/lib/api/response/decorators";

export class TokensResponse extends FloteResponse {
    @ResponseField()
    public accessToken: string;
    @ResponseField()
    public refreshToken: string
}
